<template>
  <div>
    <ed-form :model="formData">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
      >
        Informações do Trabalhador(a)
      </div>

      <ed-input-auto-complete
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 pa-0"
        label="Trabalhador (a)"
        placeholder="Digite o nome do trabalhador(a)"
        v-model="formData.funcionario"
        :items="list.funcionario"
        :loading="loadingFuncionario"
        @search="getFuncionario"
        @input="formatarFuncionario"
        clearable
        required
        is-object
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5"
        label="Frente de Trabalho"
        v-model="formData.id_fdt"
        :items="list.fdt"
        :loading="loadingFdt"
        :disabled="!formData.funcionario"
        itemText="fdt"
        @input="getFuncao"
        required
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5"
        label="Função"
        v-model="formData.id_funcao"
        :items="list.funcao"
        :loading="loadingFuncao"
        :disabled="!formData.funcionario || !formData.id_fdt"
        @input="getGHE"
        required
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="GHE (Setor)"
        v-model="formData.id_ghe"
        :items="list.ghe"
        :loading="loadingGhe"
        :disabled="
          !formData.funcionario || !formData.id_fdt || !formData.id_funcao
        "
        itemGroup
        required
      />

      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3"
        label="Data do Agendamento da Consulta"
        v-model="formData.data_age"
        info="A data do agendamento não garante horário disponível. A disponibilidade deve ser confirmado no dia da consulta diretamente com a clínica que realizará a consulta."
        :disabled="
          !formData.funcionario ||
          !formData.id_fdt ||
          !formData.id_funcao ||
          !formData.id_ghe
        "

        :maxDaysTomorrow="15"
        @input="getCredenciada"
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Observações"
        type="textarea"
        v-model="formData.obs"
        :disabled="
          !formData.funcionario ||
          !formData.id_fdt ||
          !formData.id_funcao ||
          !formData.id_ghe
        "
      />

      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
      >
        Informações da Consulta
      </div>

      <ed-input-select-tipo
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Tipo de Consulta"
        name="id_tipo_aso"
        tipo="46"
        v-model="formData.id_tipo_aso"
        :disabled="
          !formData.funcionario ||
          !formData.id_fdt ||
          !formData.id_funcao ||
          !formData.id_ghe ||
          !formData.data_age
        "
        :disabledItem="disabilitarConsulta"
        @input="getCredenciada"
        isRadio
        required
      >
        <div
          slot="id_tipo_aso_50"
          class="pb-1"
          v-if="formData.id_tipo_aso == 50"
        >
          <div class="row ml-0 mr-0 mb-0">
            <ed-input-select
              class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
              label="Nova Frente de Trabalho"
              v-model="formData.id_mf_fdt"
              :items="list.fdt"
              :loading="loadingFdt"
              :disabled="!formData.funcionario"
              itemText="fdt"
              @input="getGheMudancaFuncao"
              required
            />

            <ed-input-select
              class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-4"
              label="Novo GHE (Setor)"
              v-model="formData.id_mf_ghe"
              :items="list.mf_ghe"
              :loading="loadingGhe"
              :disabled="!formData.id_mf_fdt"
              @input="getFuncaoMudancaFuncao"
              itemGroup
              required
            />

            <ed-input-select
              class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5"
              label="Nova Função"
              v-model="formData.id_mf_funcao"
              :items="list.mf_funcao"
              :loading="loadingFuncao"
              :disabled="!formData.id_mf_fdt || !formData.id_mf_ghe"
              @input="getCredenciada"
              required
            />
          </div>
        </div>

        <div
          :slot="'id_tipo_aso_' + formData.id_tipo_aso"
          class="pb-1"
          v-if="formData.id_tipo_aso == 52 || formData.id_tipo_aso == 48"
        >
          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3"
            label="Periodicidade"
            v-model="formData.periodicidade"
            :items="listaPeriodicidade"
            :loading="!$root.$session.pcmso"
            required
          />
        </div>
      </ed-input-select-tipo>

      <div slot="form-footer">
        <div class="row">
          <div
            class="col-md-12 pa-0"
            v-if="
              formData.id_tipo_aso != 50 ||
              (formData.id_tipo_aso == 50 &&
                formData.id_mf_fdt &&
                formData.id_mf_ghe &&
                formData.id_mf_funcao)
            "
          >
            <ed-credenciada :parent="this" />
          </div>
          <div slot="form-footer" class="col-md-12 text-center mt-5">
            <ed-button
              type="success"
              @click="salvar"
              size="big"
              icon="fa fa-floppy-o"
              label="Gerar Consulta"
              :disabled="!formData.id_tipo_aso || !Array.isArray(tabela_preco)"
              :title="
                !formData.id_tipo_aso
                  ? 'Para continuar selecione o tipo da consulta'
                  : 'Clique aqui para gerar a consulta'
              "
            />
          </div>
        </div>
      </div>
    </ed-form>
  </div>
</template>

<script>
import EdCredenciada from "./credenciada/index";
import {
  EdForm,
  EdButton,
  EdInputText,
  EdInputDate,
  EdInputAutoComplete,
  EdInputSelect,
  EdInputSelectTipo,
} from "template";
export default {
  components: {
    EdCredenciada,
    EdForm,
    EdButton,
    EdInputText,
    EdInputDate,
    EdInputAutoComplete,
    EdInputSelect,
    EdInputSelectTipo,
  },
  watch: {},
  data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      formData: {
        id: 0,
        data_age: this.$utilidade.toDate(null, true),
        periodicidade: 12,
        id_tabela_preco: null,
        id_funcionario: null,
        funcionario: null,
        id_tipo_aso: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        id_mf_fdt: null,
        id_mf_ghe: null,
        id_mf_funcao: null,
        exames: [],
        obs: null,
        pcd: 0,
      },
      formFilter: {
        order: "ate_cli_cre.nome",
        id_estado: null,
        id_cidade: null,
        id_tipo_tabela_preco: null,
        preco: null,
      },
      list: {
        fdt: [],
        ghe: [],
        mf_ghe: [],
        mf_funcao: [],
        funcao: [],
        funcionario: [],
      },
      tabHistorico: "tab-credenciada",
      loadingPCMSO: false,
      loadingFdt: false,
      loadingGhe: false,
      loadingFuncao: false,
      loadingTabelaPreco: false,
      loadingFuncionario: false,
      loadingConsultaHistorico: false,
      pcmso: null,
      consulta_historico: null,
      tabela_preco: null,
    };
  },

  created() {},

  mounted() {
    this.getFuncionario();
  },

  computed: {
    listaPeriodicidade() {
      let arrayPeriodicidade = [];

      this.formData.periodicidade = 12;

      if (this.formData.id_tipo_aso == 48) {
        this.formData.periodicidade = 6;
      }

      if (this.$root.$session.pcmso) {
        this.$root.$session.pcmso.forEach((pcmso, index) => {
          let periodicidade = pcmso.periodicidade;

          if (this.formData.id_tipo_aso == 48) {
            periodicidade = (pcmso.apos_adm == 0 ? 6 : pcmso.apos_adm);
          }

          if (
            periodicidade > 0 &&
            !this.$utilidade.arrFindByField(
              arrayPeriodicidade,
              "id",
              periodicidade
            )
          ) {
            arrayPeriodicidade.push({
              id: periodicidade,
              nome: periodicidade + " meses",
            });
          }
        });
      }

      return arrayPeriodicidade.sort((a, b) =>
        a.id > b.id ? 1 : b.id > a.id ? -1 : 0
      );;
    },

    disabilitarConsulta() {
      return (item) => {
        switch (item.id) {
          case 47:
            return (
              this.formData.funcionario && this.formData.funcionario.adm == 1
            );
            break;

          case 48:
            return (
              this.formData.funcionario &&
              this.formData.funcionario.apos_adm == 1
            );
            break;

          case 51:
            return (
              this.formData.funcionario && this.formData.funcionario.dem == 1
            );
            break;

          default:
            return false;
            break;
        }
      };
    },
  },

  methods: {
    formatarFuncionario() {
      if (this.formData.funcionario) {
        this.formData.id_funcionario = this.formData.funcionario.id;
        this.formData.id_fdt = this.formData.funcionario.id_pcmso;
        this.formData.id_funcao = this.formData.funcionario.id_funcao;
        this.formData.id_ghe = this.formData.funcionario.id_ghe;
        this.getFuncao();
      }
    },

    getFDT() {
      this.loadingFdt = true;
      this.list.fdt = [];

      let filter = {
        ativo: 1,
      };

      this.$root.$request
        .get("pcmso/fdt", {
          filter: filter,
        })
        .then((result) => {
          this.loadingFdt = false;

          if (result.status == 200) {
            this.list.fdt = result.data.data;

            if (this.formData.id_fdt) {
              if (
                !this.$utilidade.arrFindByField(
                  this.list.fdt,
                  "id",
                  this.formData.id_fdt
                )
              ) {
                this.formData.id_fdt = null;
                this.formData.id_funcao = null;
                this.formData.id_ghe = null;
              }
            }
          }
        });
    },

    getFuncao(_search) {
      this.list.funcao = [];

      if (!this.formData.id_fdt) return;

      this.loadingFuncao = true;

      var filter = {
        id_fdt: this.formData.id_fdt,
      };

      this.$root.$request
        .get("pcmso/ghe/funcao", {
          filter: filter,
          pagination: 1000,
        })
        .then((result) => {
          this.loadingFuncao = false;

          if (result.status == 200) {
            this.list.funcao = result.data.data;

            if (this.formData.id_funcao) {
              if (
                !this.$utilidade.arrFindByField(
                  this.list.funcao,
                  "id",
                  this.formData.id_funcao
                )
              ) {
                this.formData.id_funcao = null;
                this.formData.id_ghe = null;
              }
            }

            this.getGHE();
          }
        });
    },

    getGHE() {
      this.list.ghe = [];

      if (!this.formData.id_fdt || !this.formData.id_funcao) return;

      this.loadingGhe = true;
      var filter = {
        id_fdt: this.formData.id_fdt,
        id_funcao: this.formData.id_funcao,
      };

      this.$root.$request
        .get("pcmso/ghe", {
          filter: filter,
          pagination: 100,
        })
        .then((result) => {
          this.loadingGhe = false;

          if (result.status == 200) {
            this.list.ghe = result.data;

            let encontrado = false;
            this.list.ghe.forEach((revisao, index) => {
              if (
                this.$utilidade.arrFindByField(
                  revisao.options,
                  "id",
                  this.formData.id_ghe
                )
              ) {
                encontrado = true;
              }
            });

            if (this.formData.id_ghe && !encontrado) {
              this.formData.id_ghe = null;
            }
          }
        });
    },

    getGheMudancaFuncao() {
      this.loadingGhe = true;
      this.mf_ghe = [];

      this.formData.id_mf_ghe = null;

      var filter = {
        id_fdt: this.formData.id_mf_fdt,
      };

      this.$root.$request
        .get("pcmso/ghe", {
          filter: filter,
          pagination: 100,
        })
        .then((result) => {
          this.loadingGhe = false;

          if (result.status == 200) {
            this.list.mf_ghe = result.data;
          }
        });
    },

    getFuncaoMudancaFuncao(_search) {
      this.loadingFuncao = true;
      this.list.mf_funcao = [];

      this.formData.id_mf_funcao = null;

      var filter = {
        id_fdt: this.formData.id_mf_fdt,
      };

      this.$root.$request
        .get("pcmso/ghe/funcao/" + this.formData.id_mf_ghe, {
          filter: filter,
          pagination: 1000,
        })
        .then((result) => {
          this.loadingFuncao = false;

          if (result.status == 200) {
            this.list.mf_funcao = result.data.data;
          }
        });
    },

    getFuncionario(_search) {
      this.loadingFuncionario = true;
      this.list.funcionario = [];

      if (this.$route.params.funcionario && !_search) {
        _search = this.$route.params.funcionario;
      }

      this.$root.$request
        .get("funcionario/0", {
          search: _search,
          pagination: 100,
        })
        .then((result) => {
          this.loadingFuncionario = false;

          if (result.status == 200) {
            this.list.funcionario = result.data.data;

            var funcionario = null;
            if (
              (funcionario = this.$utilidade.arrFindByField(
                this.list.funcionario,
                "id",
                this.$route.params.funcionario
              ))
            ) {
              this.formData.funcionario = funcionario;
              this.formatarFuncionario();
            }
          } else {
            this.$utilidade.$notify.error(result.data);
          }

          this.getFDT();
        });
    },

    ordenar(tabela_preco) {
      for (let index = 0; index < tabela_preco.length; index++) {

        //REAPROVEITAMENTO
        tabela_preco[index].exames.consulta = tabela_preco[
          index
        ].exames.consulta.sort((a, b) =>
          a.id_con_rea > b.id_con_rea ? 1 : b.id_con_rea > a.id_con_rea ? -1 : 0
        );

        //DEMOSTRATIVO
        tabela_preco[index].exames.consulta = tabela_preco[
          index
        ].exames.consulta.sort((a, b) =>
          a.id_con_dem > b.id_con_dem ? 1 : b.id_con_dem > a.id_con_dem ? -1 : 0
        );

        tabela_preco[index].exames.demonstrativo = tabela_preco[
          index
        ].exames.demonstrativo.sort((a, b) =>
          a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0
        );
      }
      return tabela_preco;
    },

    getCredenciada(page, search) {
      this.tabHistorico = "tab-credenciada";

      if (
        (this.formData.id_tipo_aso == 50 &&
          (!this.formData.id_mf_fdt || !this.formData.id_mf_ghe)) ||
        !this.formData.id_tipo_aso ||
        !this.formData.id_ghe ||
        !this.formData.id_funcionario ||
        !this.formData.data_age
      ) {
        return;
      }

      this.$root.$loading.set(true, "Carregando exames");

      var filter = Object.assign(
        {
          id_fdt:
            this.formData.id_tipo_aso == 50
              ? this.formData.id_mf_fdt
              : this.formData.id_fdt,
          id_funcao:
            this.formData.id_tipo_aso == 50
              ? this.formData.id_mf_funcao
              : this.formData.id_funcao,
          id_ghe:
            this.formData.id_tipo_aso == 50
              ? this.formData.id_mf_ghe
              : this.formData.id_ghe,
          periodicidade:
            this.formData.id_tipo_aso == 52 || this.formData.id_tipo_aso == 48
              ? this.formData.periodicidade
              : -1,
          id_funcionario: this.formData.id_funcionario,
          id_tipo_tabela_preco: this.formFilter.id_tipo_tabela_preco,
          hoje: this.formData.data_age,
          id_tipo_aso: [this.formData.id_tipo_aso],
          pcd: this.formData.pcd,
        },
        this.formFilter
      );

      this.$root.$request
        .get("tabela-preco", {
          search: search,
          page: page,
          filter: filter,
        })
        .then((result) => {
          this.$root.$loading.set(false);

          console.log(result);
          if (result.status == 200) {
            this.tabela_preco = this.ordenar(result.data);

            for (let index = 0; index < this.tabela_preco.length; index++) {
              var tabela_preco = this.tabela_preco[index],
                valor = 0,
                valor_servico = 0,
                valor_total = 0;

              if (
                (tabela_preco.credenciada &&
                  tabela_preco.credenciada.padrao == "1") ||
                index == 0
              ) {
                this.formData.id_tabela_preco = tabela_preco.id;
              }

              for (let j = 0; j < tabela_preco.exames.consulta.length; j++) {
                valor += this.$utilidade.moneyToFloat(
                  tabela_preco.exames.consulta[j].valor_venda
                );
                valor_servico += this.$utilidade.moneyToFloat(
                  tabela_preco.exames.consulta[j].valor_servico
                );
                valor_total += this.$utilidade.moneyToFloat(
                  tabela_preco.exames.consulta[j].valor_total
                );
              }

              this.tabela_preco[index].total_exames =
                tabela_preco.exames.consulta.length;

              this.tabela_preco[
                index
              ].total_exames_realizar = tabela_preco.exames.consulta.filter(
                (exame) => {
                  return !exame.id_con_dem && !exame.id_con_rea;
                }
              ).length;

              this.tabela_preco[index].valor = this.$utilidade.floatToMoney(
                valor
              );
              this.tabela_preco[
                index
              ].valor_servico = this.$utilidade.floatToMoney(valor_servico);
              this.tabela_preco[
                index
              ].valor_total = this.$utilidade.floatToMoney(valor_total);
            }
          } else {
            this.tabela_preco = result.data;
          }
        });
    },

    salvar() {
      this.$root.$loading.set(true, "Gerando consulta");
      this.response = {};

      let formData = Object.assign(this.formData, {});

      var filter = Object.assign(
        {
          id_fdt:
            this.formData.id_tipo_aso == 50
              ? this.formData.id_mf_fdt
              : this.formData.id_fdt,
          id_funcao:
            this.formData.id_tipo_aso == 50
              ? this.formData.id_mf_funcao
              : this.formData.id_funcao,
          id_ghe:
            this.formData.id_tipo_aso == 50
              ? this.formData.id_mf_ghe
              : this.formData.id_ghe,
          periodicidade:
            this.formData.id_tipo_aso == 52 || this.formData.id_tipo_aso == 48
              ? this.formData.periodicidade
              : -1,
          id_funcionario: this.formData.id_funcionario,
          id_tipo_tabela_preco: this.formFilter.id_tipo_tabela_preco,
          hoje: this.formData.data_age,
          id_tipo_aso: [this.formData.id_tipo_aso],
          pcd: this.formData.pcd,
        },
        this.formFilter
      );

      formData.periodicidade = filter.periodicidade;

      this.$root.$request
        .put("consulta/externa/cadastrar", formData, {
          filter: filter,
        })
        .then((result) => {
          this.$root.$loading.set(false);
          this.response = result;

          if (result.status == 200) {
            this.$root.$notify.success("Dados atualizados com sucesso");

            if (this.$route.name == "empresa.consulta.cad") {
              this.$router.push({
                name: "empresa.consulta.edt",
                params: {
                  consulta: result.data.id,
                },
              });
            }
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// cadastrar.vue?00376a97